import { render, staticRenderFns } from "./reject-dialog.vue?vue&type=template&id=4c8869fa&"
import script from "./reject-dialog.vue?vue&type=script&lang=js&"
export * from "./reject-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports